import {IM_CODES} from "../../constants/imcodes";

export default class Searcher{

	private items:string[];
	private itemsWithCaps:string[];

    constructor(){
		this.itemsWithCaps=Object.keys(IM_CODES);
		this.items=[];
		for(let i=0;i<this.itemsWithCaps.length;i++){
			this.items[i]=this.itemsWithCaps[i].toLowerCase();
		}
    }

    findImages(searchText:string){
		let searchRes:string[][]=[];
		let indexFound=this.items.indexOf(searchText);
		if(indexFound!==-1){
			let searchTextWithCaps=this.itemsWithCaps[indexFound];
			for(let i=0;i<IM_CODES[searchTextWithCaps].length;i++){
				searchRes.push([searchTextWithCaps,IM_CODES[searchTextWithCaps][i]])
			}

			//this.items can have duplicate entries when IM_CODES has one capitalized and one uncapitalized version of the same word
			//the duplicate is always immediated after 
			//this ensures that the ims for the duplicates are also added to searchRes
			if(indexFound+1<this.items.length&&this.items[indexFound+1]===searchText){
				let searchTextWithCaps=this.itemsWithCaps[indexFound+1];
				for(let i=0;i<IM_CODES[searchTextWithCaps].length;i++){
					searchRes.push([searchTextWithCaps,IM_CODES[searchTextWithCaps][i]])
				}
			}
		}
		return searchRes;
    }
	
	findSimilarText(searchText:string){
		//this should be more complext - have part matches for later in strings and etc
		//need count list from old uploaded stuff and then order text matches based on num previously uploaded
		let matches:string[]=[];
        if(searchText.length>0){
            matches=this.items.filter((item)=>{
                return item.startsWith(searchText)&&item!==searchText;
                // return item.startsWith(searchText);
            })
            matches=matches.slice(0,12);//review this number
        }
		//remove duplicate matches - this only happens when this.items has 2 entries for same text bc of capitalization
		var uniqMatches = [ ...new Set(matches) ];
        return uniqMatches;
	}
}
   	//also think about matching working both ways.  Does a search for big match 'big dog' and a search for dog also match 'big dog'.  What about big dog search matching to 'dog'

	// search(): searches for specified value in the string
	// indexOf(): returns the first index of occurrence of a value
	// lastIndexOf(): returns the last index of occurrence of a value
	// includes(): checks if given string is found inside a string
	// startsWith(): checks if a string begins with a specified string
	// endsWith(): checks if a string ends with a specified string
	// match(): returns result of matching string with a regex
	// matchAll(): returns iterator of results matching with a regex

	// if(product.name.toLowerCase().indexOf(props.filterText.toLowerCase())===-1)return;
	// if(product.name.toLowerCase().includes(props.filterText.toLowerCase())===false)return;
	// if(product.name.toLowerCase().match(props.filterText.toLowerCase())===null)return;
	// .trim().